import React from 'react';
import '../../styles/buildInfo.css';
import GitInfo from 'react-git-info/macro';

function BuildInfo() {
    const gitInfo = GitInfo();

    return (
        <div className="buildInfoView">
            <div
                style={{
                    marginLeft: '30px',
                }}
            >
                <p>git brach: {gitInfo.branch}</p>
                <p>git has: {gitInfo.commit.shortHash}</p>
                <p>git message: {gitInfo.commit.message}</p>
                <p>fecha del commit: {gitInfo.commit.date}</p>
            </div>
        </div>
    );
}

const BuildInfoPage = () => <BuildInfo />;

export default BuildInfoPage;